import { render } from "./MenuItem.vue?vue&type=template&id=2eadef3a"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/documedias/gitlab/virtuell/unionconf2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__